import { endOfQuarter, startOfQuarter } from 'date-fns'
import { useMemo } from 'react'

import { mainColors, SMedium } from '@avantstay/backoffice-core'

import * as S from '../DatePicker.styles'
import { ViewComponentProps } from '../DatePicker.types'
import { buildAutoScrollableRef, getQuarterViewPresets } from '../DatePicker.utils'

export const QuarterView = ({ value, preset, onChange }: ViewComponentProps) => {
  const quarterViewPresets = useMemo(() => getQuarterViewPresets(), [])

  const handleSelectPreset = ({
    newPreset,
    quarter,
    year,
  }: {
    newPreset: string
    quarter: number
    year: number
  }) => {
    // Convert quarter index (0-3) to starting month
    const referenceDate = new Date(year, quarter * 3)
    onChange({
      value: { startDate: startOfQuarter(referenceDate), endDate: endOfQuarter(referenceDate) },
      metadata: { preset: newPreset },
    })
  }

  return quarterViewPresets.map(({ year, presets }) => (
    <div
      key={`quarter-view-${year}`}
      ref={buildAutoScrollableRef({ presetYear: year, startDate: value?.startDate })}
    >
      <SMedium color={mainColors.neutralExtraDark}>{year}</SMedium>

      <S.ViewGrid $columns={2}>
        {presets.map((quarterViewPreset, index) => (
          <S.ViewPresetButton
            key={`quarter-view-${year}-preset-${quarterViewPreset}`}
            aria-selected={value?.startDate?.getFullYear() === year && quarterViewPreset === preset}
            onClick={() =>
              handleSelectPreset({ newPreset: quarterViewPreset, quarter: index, year })
            }
          >
            {quarterViewPreset}
          </S.ViewPresetButton>
        ))}
      </S.ViewGrid>
    </div>
  ))
}
